import { Link } from 'react-router-dom';
import Logo from '../assets/images/Logo.svg';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import humanHealth from '../assets/images/human_health.svg';
import impactsCircles from '../assets/images/impacts_circles.svg';
function PfasImpacts() {
  return (
    <>
      <div className='navigation'>
        <div className='logo'>
          <img src={Logo} alt='Quantum logo' />
        </div>
        <div className='nav'>
          <Link to='/pfas' className='pfas-btn-white-back'>
            <div className='nav-text-back'>Previous</div>
          </Link>
          <Link to='/'>
            <div className='nav-home'></div>
          </Link>
          <div className='nav-page-nr'>3/6</div>
          <Link to='/pfascycle' className='pfas-btn-blue-next'>
            <div className='nav-text-next'>Next</div>
          </Link>
        </div>
      </div>
      <div className='pfas-impacts pfas-container'>
        <Row>
          <div className='impacts'>
            <Col xs={12} lg={6}>
              <div className='text-left'>
                <div className='slogan'>Health concerns</div>
                <div className='headline'>Impacts on human health</div>
                <div className='text'>
                  Scientific research is still ongoing on how different levels
                  of exposure to different PFAS can lead to a variety of health
                  effects. Exposure to high levels of certain PFAS may lead to
                  adverse health outcomes.
                </div>
                <div className='headline-small'>
                Incidence of PFAS-related adverse health outcomes:
                </div>

                <div className='impacts-explain'>
                  <img src={impactsCircles} alt='' />
                </div>
              </div>
            </Col>
            <Col xs={12} lg={6}>
              <div className='image-right'>
                <div className='impacts-image'>
                  <img src={humanHealth} alt='Pfas impacts on human health' />
                </div>
                <div className='image-source'>
                  <b>Source:</b>{' '}
                  <a href='https://www.eea.europa.eu/publications/emerging-chemical-risks-in-europe/emerging-chemical-risks-in-europe'>
                    Emerging chemical risks in Europe - 'PFAS'
                  </a>
                </div>
              </div>
            </Col>
          </div>
        </Row>
      </div>
    </>
  );
}

export default PfasImpacts;
